import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS } from "components";

import { ELIGIBLE_COUNT_WARNING_THRESHOLD } from "../consts";
import { AppliedFilterEntry, AppliedFiltersDisplay } from "../types";
import { CountBox } from "./CountBox";
import { InfoAlert } from "./Alerts";
import { RecalculationStatusAlerts } from "./RecalculationStatusAlerts";

interface FilterModeTabProps {
  filters: AppliedFiltersDisplay;
  eligibleCount: number | null;
  isCountLoading: boolean;
  isJobRunning: boolean;
}

const FilterEntry = ({ label, value, isOn }: AppliedFilterEntry) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
    <Typography sx={{ fontSize: "12px", color: "#8aa0a0", fontWeight: 500 }}>
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: "12px",
        color: isOn ? COLORS.Mainblue : "#b0c0c0",
        fontWeight: 500,
      }}
    >
      {value}
    </Typography>
  </Box>
);

export const FilterModeTab = ({
  filters,
  eligibleCount,
  isCountLoading,
  isJobRunning,
}: FilterModeTabProps) => {
  const isWarning = !isCountLoading && (eligibleCount ?? 0) > ELIGIBLE_COUNT_WARNING_THRESHOLD;

  return (
    <Box>
      <Box sx={{ pb: 1.75, mb: 1.75, borderBottom: "1px solid #e8eeee" }}>
        <Typography
          sx={{
            fontSize: "10px",
            fontWeight: 700,
            color: COLORS.Mainblue,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            mb: "10px",
          }}
        >
          Applied Filters
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "8px 20px",
          }}
        >
          {filters.map((entry) => (
            <FilterEntry key={entry.label} {...entry} />
          ))}
        </Box>
      </Box>

      <CountBox
        label="Eligible Bills"
        sublabel="Matching current filters"
        count={eligibleCount}
        isLoading={isCountLoading}
        isWarning={isWarning}
      />

      <RecalculationStatusAlerts
        isJobRunning={isJobRunning}
        isWarning={isWarning}
        infoAlert={<InfoAlert />}
      />
    </Box>
  );
};
